import React from 'react'
import notFoundImage from './../../../assets/global_assets/assets/notfound.gif';


function NotFound() {
    return (
        <div
        style={{
          height: '90vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <img
          src={notFoundImage}
          alt="404 Not Found"
          style={{
            width: '300px',
            maxWidth: '90%',
          }}
        />
        {/* <h1 style={{ marginTop: '1rem' }}>404 - Page Not Found</h1> */}
      </div>
    );
  }


export default NotFound
